import { HistoryItemParamsState } from '@pages/History/types';
import { HistoryItem } from '@services/AuthService/query/loadUserQuery';
import { useEffect, useState } from 'react';

import { getHistoryDataLoader } from './helpers';

/**
 * Загрузка данных элемента истории по короткой ссылке
 */
export const useHistoryItemData = (historyItem: HistoryItem) => {
  const { type_calculation: typeCalculation, short_link: shortLink } = historyItem;

  const dataLoader = getHistoryDataLoader(typeCalculation);

  const [paramsState, setParamsState] = useState<HistoryItemParamsState>({
    isLoading: !!dataLoader,
    isError: false,
    data: null,
  });

  useEffect(() => {
    if (!dataLoader) {
      return;
    }

    let isActual = true;

    setParamsState({ isLoading: true, isError: false, data: null });
    dataLoader(shortLink)
      .then((data) => {
        isActual && setParamsState({ isLoading: false, isError: false, data });
      })
      .catch(() => {
        isActual && setParamsState({ isLoading: false, isError: true, data: null });
      });

    return () => {
      isActual = false;
    };
  }, [shortLink, typeCalculation]);

  return {
    paramsState,
    isSupported: !!dataLoader,
  };
};
